import { del, get, post, put } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const listApps = async (page_at, page_size) => {
    if (shouldLogApiCalls) {
        console.log('List apps attempt:');
    }
    
    return get(`/app?page_at=${page_at}&page_size=${page_size}`);
}

export const listUserApps = async (page_at, page_size) => {
    if (shouldLogApiCalls) {
        console.log('List user apps attempt:');
    }
    
    return get(`/user/app?page_at=${page_at}&page_size=${page_size}`);
}

export const createUserApp = async (data) => {
    if (shouldLogApiCalls) {
        console.log('Create user app attempt:');
    }
    
    return post(`/user/app`, data);
}

export const updateUserApp = async (id, data) => {
    if (shouldLogApiCalls) {
        console.log('Update user app attempt:');
    }
    
    return put(`/user/app/${id}`, data);
}

export const deleteUserApp = async (id) => {
    if (shouldLogApiCalls) {
        console.log('Delete user app attempt:');
    }
    
    return del(`/user/app/${id}`);
}